/**
 * Client-side blog HTML policy — keep in sync with `sanitizeBlogHtml` in
 * `src/backend/combined-server.js`.
 */
export const BLOG_HTML_ALLOWED_TAGS = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'ul',
  'ol',
  'li',
  'a',
  'strong',
  'b',
  'em',
  'i',
  'code',
  'pre',
  'blockquote',
  'div',
  'span',
  'br',
  'hr',
  'img'
];

/** DOMPurify options for rich blog body HTML */
export const blogHtmlPurifyConfig = {
  ALLOWED_TAGS: BLOG_HTML_ALLOWED_TAGS,
  ALLOWED_ATTR: ['href', 'rel', 'target', 'src', 'alt', 'title'],
  ALLOW_DATA_ATTR: false,
  FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'textarea', 'button'],
  FORBID_ATTR: [
    'onerror',
    'onload',
    'onclick',
    'onmouseover',
    'onmouseenter',
    'onfocus',
    'onblur',
    'oninput',
    'onkeydown',
    'onkeyup'
  ]
};
